import { render } from "./RecetaGenerar.vue?vue&type=template&id=585fabe4&scoped=true"
import script from "./RecetaGenerar.vue?vue&type=script&lang=js"
export * from "./RecetaGenerar.vue?vue&type=script&lang=js"

import "./RecetaGenerar.vue?vue&type=style&index=0&id=585fabe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585fabe4"]])

export default __exports__